<template>
    <div>
        <div class="header">
            <a href="/">
                <img src="../../images/header-logo.png" alt="Logo" class="logo">
            </a>
        </div>
        <div class="modelings container py-5">
            <div class="table-responsive" >
                <div v-bind:class="['alert alert-info', hidden]" role="alert">
                    Please enter your credentials <RouterLink to="/"><b>here</b></RouterLink>.
                </div>
                <table class="table table-bordered table-responsive-md">
                    <thead>
                        <tr>
                            <th class="text-center">{{ $t('modelings') }}</th>
                        </tr>
                        <tr>
                            <td style="padding:0" >
                                <input class="form-control" style="border:none" :placeholder="$t('filterByName')" v-model="filterInput" type="search">
                            </td>
                        </tr>
                    </thead>
                    <tbody v-if="listOfModelings.length > 0">
                        <tr v-for="(item, i) in listOfModelings" :key="i">
                            <td>
                                <RouterLink :to="{ name: 'modeling', params: { id: item.id } }">
                                    {{ item.name }} 
                                </RouterLink>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            {{ $t('noAssignedModeling') }}
                        </tr>
                    </tbody>
                    
                </table>
            </div>
            <div class="under-buttons">
                <div v-if="loginInfo.userrole == 'Admin' && loginInfo.isAuthenticated" style="float:left">
                    <RouterLink to="settings/modelings" class="btn btn-secondary"> 
                        {{ $t('settings') }}
                    </RouterLink>
                </div>
                <div class="logout">
                    <button type="button" class="btn btn-secondary" @click="changeUser()" style="float:right; margin-right:20px">
                        {{ $t('logout') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ModelingApi from "../../api/server/modeling";
import authApi from "../../api/server/authorization"

export default {
    name: "ModelingList",
    mounted() {
        this.requestData();
    },
    computed: { 
        listOfModelings() {
            var modelingList = this.modelingList;

            if (this.filterInput) {
                const lowerCaseFilter = this.filterInput.toLowerCase()
                modelingList = modelingList.filter((viz) => { 
                    if(viz.name.toLowerCase().includes(lowerCaseFilter))

                    return viz;
                });
            }

            return modelingList.sort((a, b) => a.name.localeCompare(b.name));
        }
    },
    methods: {
        async requestData() {
            try {
                this.loginInfo = await authApi.auth();
                var groupId = this.loginInfo.usergroup;
                var allModelings = await ModelingApi.modelingList();
                if(this.loginInfo.userrole == "Admin") {
                    this.modelingList = allModelings;
                } else {
                    for (var i in allModelings) {
                        var modeling = allModelings[i];
                        var parsedContent = JSON.parse(modeling.content);
                        if (parsedContent["groups"]) {
                            let findIndex = parsedContent["groups"].findIndex(g => g.groupId == groupId)
                            if (findIndex > -1) {
                                this.modelingList.push(modeling);
                            } 
                        }
                    }
                }
            } catch (error) {
                // TODO: error
            }
        },
        showAlert() {
            this.hidden = "showAlertBlock";
        },
        async changeUser() {
            await authApi.logout();
            this.$router.push('/');
        }
    },
    data() {
        return {
            loginInfo: {
                isAuthenticated: false,
                usergroup: null,
                userrole: ""
            },
            hidden: "hidden",
            userrole: "",
            modelingList: [],
            filterInput: "",
            params: "",
            name: ""
        }
    }
};
</script>